import React from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';

interface RevealCardProps {
  frontText: string;
  backText: string;
  onReveal: (optionId: number) => void;
  isRevealed: boolean;
  optionId: number;
}

export const RevealCard: React.FC<RevealCardProps> = ({ frontText, backText, onReveal, isRevealed, optionId }) => {
  const handleReveal = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isRevealed) {
      console.log('Revealing card with optionId:', optionId);
      onReveal(optionId);
    }
  };

  if (!frontText && !backText) {
    console.warn('RevealCard received empty texts');
    return null;
  }

  return (
    <Card 
      sx={{ 
        cursor: !isRevealed ? 'pointer' : 'default',
        minHeight: 200,
        height: '100%',
        position: 'relative',
        backgroundColor: isRevealed ? 'rgba(25, 118, 210, 0.12)' : 'background.paper',
        perspective: 1000,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderColor: isRevealed ? 'primary.main' : 'divider',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          borderColor: 'primary.main',
        },
      }}
    >
      <div style={{ 
        position: 'relative', 
        width: '100%', 
        height: '100%',
        display: 'flex',
        flexDirection: 'column' 
      }}>
        <motion.div
          initial={false}
          animate={{ 
            rotateY: isRevealed ? 180 : 0,
            opacity: 1 
          }}
          transition={{ duration: 0.5 }}
          style={{ 
            position: 'absolute', 
            width: '100%', 
            height: '100%', 
            backfaceVisibility: 'hidden',
            transformStyle: 'preserve-3d'
          }}
        >
          <CardContent sx={{ 
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 3,
            transform: isRevealed ? 'rotateY(180deg)' : 'none'
          }}>
            <Typography 
              variant="h6" 
              align="center"
              sx={{ 
                mb: 2,
                color: isRevealed ? 'primary.main' : 'text.primary',
                fontWeight: isRevealed ? 500 : 400
              }}
            >
              {isRevealed ? backText : frontText}
            </Typography>
            {!isRevealed && (
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleReveal}
                sx={{ 
                  mt: 'auto',
                  minWidth: 120,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  }
                }}
              >
                Reveal
              </Button>
            )}
          </CardContent>
        </motion.div>
      </div>
    </Card>
  );
};